const CAMERA_DISABLED_PROJECTS = ['sbaeld'];

export const cameraEnabled = (projectName: string) =>
  Boolean(projectName) && !CAMERA_DISABLED_PROJECTS.includes(projectName);
